import '@core/patches/date-fix';
import '@core/patches/global-helpers';

import Vue from 'vue';

import router from '@core/router';
import ErrorService from '@core/services/ErrorService';
import '@core/services/CalculatorService';
import store from '@core/store';

import '@plugins/http';
import '@plugins/ideal-postcodes';
import '@/mixins';
import '@/directives';
import '@/global-components';
import '@plugins/lodash';
import i18n from '@plugins/i18n';
import vuetify from '@plugins/vuetify';

import App from '@/components/App.vue';
import '@/scss/app.scss';

Vue.config.productionTip = false;
Vue.config.errorHandler = (error, vm, info) => ErrorService.onError(error, { vm, info });

window.Vue = new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#gi-app');

ErrorService.init();
